import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { isTreatment, safeBoolean } from '../../utils/utils'
import { AtfTreatmentProps } from '../../reducers/features'
import * as badgeSt from './badge.module.scss'

export interface UhdBadgeProps extends AtfTreatmentProps {
  isUhd?: boolean
}

export const Uhd = ({ isUhd, atfTreatment }: UhdBadgeProps) => (
  safeBoolean(isUhd) &&
  (<Badge use={badges.BORDERED_TEXT}>
    <span {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})} data-automation-id="uhd-badge">UHD</span>
  </Badge>) || null
)
